import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

const AD_CLIENT = 'ca-pub-8964077418009594';

const AdBanner = ({ slot, format = 'auto', style = {}, className = '' }) => {
  const adRef = useRef(null);
  const location = useLocation();
  const initialized = useRef(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    initialized.current = false;
    setVisible(false);
  }, [location.pathname, slot]);

  useEffect(() => {
    if (!slot || initialized.current) return;
    if (!adRef.current) return;
    if (adRef.current.getAttribute('data-adsbygoogle-status')) return;

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      initialized.current = true;
    } catch (e) {}

    // AdSense imposta data-ad-status="unfilled" se non ha annunci, altrimenti inietta iframe
    const check = setInterval(() => {
      if (!adRef.current) { clearInterval(check); return; }
      const status = adRef.current.getAttribute('data-ad-status');
      const hasIframe = adRef.current.querySelector('iframe');
      if (hasIframe) { setVisible(true); clearInterval(check); }
      else if (status === 'unfilled' || status === 'done') { clearInterval(check); }
    }, 300);

    const timeout = setTimeout(() => clearInterval(check), 5000);
    return () => { clearInterval(check); clearTimeout(timeout); };
  }); // eslint-disable-line react-hooks/exhaustive-deps

  if (!slot) return null;

  return (
    <div
      className={`ad-banner-wrapper ${className}`}
      style={visible ? { textAlign: 'center', overflow: 'hidden', ...style } : { display: 'none' }}
      aria-label="Annuncio pubblicitario"
    >
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdBanner;
